import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import * as models from '../../models'
import type { Manager } from '../manager'

export const createCytoscapeInstance = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.bind.observe().pipe(
      rxjsUtils.latestFrom(({ data }) => ({
        binding: rxjs.of(data),
        chart: feature.selectors.getChart({ chartId: data.chartId })
          .asObservable,
      })),
      rxjs.mergeMap(({ binding, chart }) => {
        const entry = models.Chart.Entry.get(binding.chartId)
        const shouldCreateImmediately =
          entry === 'proposed' || chart?.areEdgesLoaded

        // Proposed charts can always instantiate immediately. Current charts can
        // also instantiate immediately whenever their edges are already loaded,
        // which is required for the stable split-view remount after proposal creation.
        if (shouldCreateImmediately) {
          return rxjs.of(null).pipe(
            rxjs.tap(() => manager.create(binding)),
            rxjs.ignoreElements(),
          )
        }

        // Current charts still wait for loadEdges success (matching chart).
        return feature.actions.loadEdges.success.observe().pipe(
          rxjs.filter(
            ({ data: { request } }) => request.chartId === binding.chartId,
          ),
          rxjs.first(),
          rxjs.tap(() => manager.create(binding)),
          rxjs.ignoreElements(),
        )
      }),
    ),
)
